//include 4 
jQuery(function(){
    window.pixelpoint.ppComponents.quickClear = function($this){
        //var $this = $(this);
        var clearButton = $(`<i class="clear-input top-left">×</i>`);
        if(!$this.val()){
            clearButton.addClass("hide");
        }
        $this.parent().append(clearButton);
        $this.on("change keyup",function(){
            if($this.val()){
                clearButton.removeClass("hide");
            }
            else{
                clearButton.addClass("hide");
            }
        });
        clearButton.on("click",function(){
            $this.val("").change();
        });
    }

    $("[data-quick-clear]").each(function(){
        window.pixelpoint.ppComponents.quickClear($(this));
    });
});